export default {
  VITE_AUTH_API_URL: import.meta.env.VITE_AUTH_API_URL,
  VITE_ANALYTICS_API_URL: import.meta.env.VITE_ANALYTICS_API_URL,
  VITE_AUDIT_API_URL: import.meta.env.VITE_AUDIT_API_URL,
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_AUTHORITY: import.meta.env.VITE_AUTHORITY,
  VITE_CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
  VITE_REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI,
  VITE_POST_LOGOUT_REDIRECT_URI: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI,
  VITE_SCOPE: import.meta.env.VITE_SCOPE,
  VITE_GOOGLE_MAP_API_KEY: import.meta.env.VITE_GOOGLE_MAP_API_KEY,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
  VITE_RESOURCE_INSTRUCTION: import.meta.env.VITE_RESOURCE_INSTRUCTION,
  VITE_RESOURCE_SUPPORT: import.meta.env.VITE_RESOURCE_SUPPORT,
  VITE_FEATURE_LIGHT_DARK_MODE: import.meta.env.VITE_FEATURE_LIGHT_DARK_MODE,
  VITE_FEATURE_FLAG_SWITCHER: import.meta.env.VITE_FEATURE_FLAG_SWITCHER,
  VITE_FEATURE_REPORT_CONSTRUCTOR_DEV_EXTREME: import.meta.env
    .VITE_FEATURE_REPORT_CONSTRUCTOR_DEV_EXTREME,
  VITE_FE_HOUSEHOLD_URL: import.meta.env.VITE_FE_HOUSEHOLD_URL,
  VITE_FEATURE_HOUSEHOLD_REDIRECT: import.meta.env
    .VITE_FEATURE_HOUSEHOLD_REDIRECT,
  VITE_FEATURE_SHOW_LANGUAGE_SWITCHER: import.meta.env
    .VITE_FEATURE_SHOW_LANGUAGE_SWITCHER,
};
